import React, {useCallback} from 'react';
import {View} from 'react-native';
import {Field} from 'redux-form';
import {BaseField} from '../../../../../shared/components/baseField';
import Screen from '../../../../../shared/components/screen';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Button} from '../../../../../shared/components/button';
import {IStateProps} from './model';
import {CardInfo} from '../../../../../shared/components/cardInfo';
import {ContentWithRightImage} from '../../../../../shared/components/contentWithRightImage';
import {Text} from '../../../../../shared/components/text';
import {useTheme} from '../../../../../shared/theme';
import {PhoneChangeField} from '../../../common/phoneChangeField';
import {EmailChangeField} from '../../../common/emailChangeField';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';

export default ({onPressChangePassword, handleSubmit, onSubmit}: IStateProps) => {
  const theme = useTheme();
  const profile = useSelector(holderProfileSelector());

  const textInputMinHeight = theme.input.common.paddingVertical * 2 + 24;
  const styles = useStyles(() => ({
    container: {
      marginHorizontal: 60,
      marginTop: 31,
      paddingBottom: theme.screen.bottomOffset,
    },
    formWrap: {
      marginRight: 317,
      paddingRight: 16,
    },
    notificationSection: {
      marginTop: 50,
    },
    notificationSectionTitle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      paddingBottom: 30,
      ...theme.fonts.h3,
    },
    notificationSectionTitleText: {
      ...theme.fonts.h4,
    },
    notificationSectionContentWidth: {
      width: 580,
    },
    checkboxlabel: {
      ...theme.fonts.h5Light,
    },
    checkboxlabelSmall: {
      ...theme.fonts.h5Light,
    },
    customCheckboxBase: {
      marginBottom: 12,
    },
    customCheckboxBaseContacts: {
      marginBottom: 30,
    },
    customCheckboxReverse: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      marginLeft: -11,
    },
    contactsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      marginBottom: 45,
    },
    contactsLeftSection: {
      width: 556,
    },
    contactsInputWrap: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      minHeight: 35,
      marginBottom: 20,
    },
    contactsInputCustomLabel: {
      width: 126,
      paddingRight: 5,
      ...theme.fonts.body,
      color: theme.color.labelText,
      lineHeight: textInputMinHeight,
    },
    contactsValue: {
      ...theme.fonts.h6,
      width: 210,
    },
    changePasswordButton: {
      marginLeft: 0,
      width: 315,
    },
    possibleChangeFieldContainer: {
      width: 348,
    },
  }));

  // const muiInputStyle = {
  //   width: 210,
  // marginTop: 0,
  // };

  const onSubmitCheckbox = useCallback(() => {
    setTimeout(handleSubmit(onSubmit));
  }, [handleSubmit]);

  return (
    <Screen>
      <View testID='desktop-settings-container-id' style={styles.container}>
        <ContentWithRightImage icon={<CardInfo showBlockButton />} hideImage>
          <View testID='desktop-settings-nested-container-id'>
            <Text testID='desktop-settings-common-label-id' type='h2'>
              Настройки
            </Text>
            <View testID='desktop-settings-form-id' style={styles.formWrap}>
              <View
                testID='desktop-settings-first-section-id'
                style={[styles.notificationSection, styles.notificationSectionContentWidth]}>
                <Text testID='notification-settings-label-id' style={styles.notificationSectionTitle}>
                  Уведомления
                </Text>
                <Field
                  testIDprefix='desktop-settings-information-share-checkbox'
                  type='checkbox'
                  component={BaseField}
                  onCustomBlur={onSubmitCheckbox}
                  name='receiveInformationShares'
                  label='Получать информацию о проведении акций'
                  dotStyle={[styles.customCheckboxBase, styles.customCheckboxReverse]}
                  labelStyle={styles.checkboxlabel}
                />
                <Field
                  testIDprefix='desktop-settings-information-offer-checkbox'
                  type='checkbox'
                  component={BaseField}
                  onCustomBlur={onSubmitCheckbox}
                  name='receiveInformationOffers'
                  label='Получать информацию о персональных предложениях'
                  dotStyle={[styles.customCheckboxBase, styles.customCheckboxReverse]}
                  labelStyle={styles.checkboxlabel}
                />
              </View>
              <View testID='desktop-settings-second-section-id' style={styles.notificationSection}>
                <View style={styles.notificationSectionTitle}>
                  <Text testID='contact-data-id' style={styles.notificationSectionTitleText}>
                    Контактные данные
                  </Text>
                </View>
                <View style={styles.contactsContainer}>
                  <View style={styles.contactsLeftSection}>
                    <View testID='possible-change-field-settings-phone-container-id' style={styles.contactsInputWrap}>
                      <Text
                        testID='possible-change-field-settings-phone-label-id'
                        style={styles.contactsInputCustomLabel}>
                        Телефон
                      </Text>
                      <PhoneChangeField
                        testID='possible-change-field-settings-phone-id'
                        style={styles.possibleChangeFieldContainer}
                        isMasked
                        onDisableMasking={() => undefined}
                      />
                    </View>
                    <View testID='possible-change-field-settings-email-container-id' style={styles.contactsInputWrap}>
                      <Text
                        testID='possible-change-field-settings-email-label-id'
                        style={styles.contactsInputCustomLabel}>
                        Эл. почта
                      </Text>
                      <EmailChangeField
                        testID='possible-change-field-settings-email-id'
                        style={styles.possibleChangeFieldContainer}
                        isMasked
                        onDisableMasking={() => undefined}
                      />
                    </View>
                  </View>
                  {/* eslint-disable-next-line react-native/no-inline-styles */}
                  <View style={{marginTop: 6}}>
                    <Field
                      testIDprefix='desktop-settings-information-isSms-checkbox'
                      type='checkbox'
                      name='events.isSms'
                      component={BaseField}
                      onCustomBlur={onSubmitCheckbox}
                      dotStyle={[styles.customCheckboxBase, styles.customCheckboxBaseContacts]}
                      label='Получать уведомления по SMS'
                      labelStyle={styles.checkboxlabelSmall}
                    />
                    <Field
                      testIDprefix='desktop-settings-information-isEmail-checkbox'
                      type='checkbox'
                      name='events.isEmail'
                      component={BaseField}
                      disabled={!profile?.email}
                      onCustomBlur={onSubmitCheckbox}
                      dotStyle={styles.customCheckboxBase}
                      label='Получать уведомления по эл. почте'
                      labelStyle={styles.checkboxlabelSmall}
                    />
                  </View>
                </View>
              </View>
            </View>
            <Button
              id='profile-change-password'
              type='transparent'
              onPress={onPressChangePassword}
              style={styles.changePasswordButton}
              text='Сменить пароль'
            />
          </View>
        </ContentWithRightImage>
      </View>
    </Screen>
  );
};
